import axios from 'axios'
import { environment } from '../config.env';

const ENDPOINT_DOMAIN = process.env.REACT_APP_ENDPOINT_DOMAIN || environment.endpoint_domain || ''

axios.defaults.baseURL = ENDPOINT_DOMAIN;
// axios.defaults.headers.common['Authorization'] = localStorage.getItem('pg_access_token');

export function getNotification(page, number_per_page) {
    return new Promise(resolve => {
        const path = '/api/v1/notification/getNotification'
        let body = {
            "page": page,
            "number_per_page": number_per_page
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}

export function setReadNotification() {
    return new Promise(resolve => {
        const path = '/api/v1/notification/setReadNotification'
        let body = {
         
        }
        let header = {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('pg_access_token')
        }
        axios.post(path, body, { headers: header }).then(res => {
            resolve(res)
        }).catch((error) => {
            resolve(false)
            //console.log(error)
        })
    })
}